// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFound_container__X0pc9 {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;
    background: linear-gradient(135deg, #191a1d 0%, #010a13 100%);
  }
  
  .NotFound_errorCode__SHPNl {
    font-size: clamp(100px, 20vw, 200px);
    font-weight: bold;
    color: white;
    margin: 0;
    line-height: 1;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .NotFound_title__V8pr3 {
    font-size: clamp(24px, 5vw, 36px);
    color: white;
    margin: 20px 0;
  }
  
  .NotFound_description__4AF8L {
    font-size: clamp(16px, 3vw, 20px);
    color: #817878;
    max-width: 600px;
    margin: 0 auto 30px;
  }
  
  .NotFound_button__SUW1x {
    padding: 12px 32px;
    font-size: 16px;
    color: white;
    background-color: #3498db;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .NotFound_button__SUW1x:hover {
    background-color: #2980b9;
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }
  
  .NotFound_illustration__zRcXD {
    max-width: 100%;
    height: auto;
    margin: 20px 0;
    animation: NotFound_float__CDyWJ 6s ease-in-out infinite;
  }
  
  @keyframes NotFound_float__CDyWJ {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-20px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  
  @media (max-width: 768px) {
    .NotFound_container__X0pc9 {
      padding: 20px;
    }
    
    .NotFound_errorCode__SHPNl {
      margin-bottom: 10px;
    }
    
    .NotFound_title__V8pr3 {
      margin: 15px 0;
    }
    
    .NotFound_description__4AF8L {
      margin-bottom: 20px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/common/UI/CSS/NotFound.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,6DAA6D;EAC/D;;EAEA;IACE,oCAAoC;IACpC,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,cAAc;IACd,2CAA2C;EAC7C;;EAEA;IACE,iCAAiC;IACjC,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,cAAc;IACd,wDAAwC;EAC1C;;EAEA;IACE;MACE,0BAA0B;IAC5B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,mBAAmB;IACrB;EACF","sourcesContent":[".container {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 20px;\n    background: linear-gradient(135deg, #191a1d 0%, #010a13 100%);\n  }\n  \n  .errorCode {\n    font-size: clamp(100px, 20vw, 200px);\n    font-weight: bold;\n    color: white;\n    margin: 0;\n    line-height: 1;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .title {\n    font-size: clamp(24px, 5vw, 36px);\n    color: white;\n    margin: 20px 0;\n  }\n  \n  .description {\n    font-size: clamp(16px, 3vw, 20px);\n    color: #817878;\n    max-width: 600px;\n    margin: 0 auto 30px;\n  }\n  \n  .button {\n    padding: 12px 32px;\n    font-size: 16px;\n    color: white;\n    background-color: #3498db;\n    border: none;\n    border-radius: 30px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: inline-block;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .button:hover {\n    background-color: #2980b9;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);\n  }\n  \n  .illustration {\n    max-width: 100%;\n    height: auto;\n    margin: 20px 0;\n    animation: float 6s ease-in-out infinite;\n  }\n  \n  @keyframes float {\n    0% {\n      transform: translateY(0px);\n    }\n    50% {\n      transform: translateY(-20px);\n    }\n    100% {\n      transform: translateY(0px);\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .container {\n      padding: 20px;\n    }\n    \n    .errorCode {\n      margin-bottom: 10px;\n    }\n    \n    .title {\n      margin: 15px 0;\n    }\n    \n    .description {\n      margin-bottom: 20px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NotFound_container__X0pc9`,
	"errorCode": `NotFound_errorCode__SHPNl`,
	"title": `NotFound_title__V8pr3`,
	"description": `NotFound_description__4AF8L`,
	"button": `NotFound_button__SUW1x`,
	"illustration": `NotFound_illustration__zRcXD`,
	"float": `NotFound_float__CDyWJ`
};
export default ___CSS_LOADER_EXPORT___;
